import {
  DestroyRef,
  Injectable,
  computed,
  inject,
  signal,
} from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ApiService, ConfigService } from '@core/services';
import { Theme } from '../models/theme.model';
import { GeneralResponse } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private _currentTheme = signal<Theme | null>(null);
  public currentTheme = computed(() => this._currentTheme());

  private apiService = inject(ApiService);
  private configService = inject(ConfigService);
  private destroyRef = inject(DestroyRef);

  public setTheme(id: string | undefined | number | null) {
    this.apiService
      .get<Theme>(`theme/${id}`)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: ({ reply }) => {
          this._currentTheme.set(reply);
          this.configService.setTheme(reply);
        },
        error: error => {
          console.log(error);
        },
      });
  }

  storeTheme(data: Theme) {
    return this.apiService.store('theme', data);
  }

  getThemes(busines?: number): Observable<GeneralResponse<Theme[]>> {
    if (busines) {
      return this.apiService.get<Theme[]>(`theme/business/${busines}`);
    } else {
      return this.apiService.get<Theme[]>('theme');
    }
  }

  getTheme(data: Theme) {
    return this.apiService.getById('theme', data.idTheme as number);
  }

  getThemeId(data: number) {
    return this.apiService.getById('theme', data);
  }

  deleteTheme(data: Theme) {
    return this.apiService.delete('theme', data.idTheme as number);
  }

  updateTheme(data: Theme) {
    return this.apiService.update(
      `theme/${data.idTheme as number}`,
      data,
      data.idTheme as number
    );
  }
}
